import gql from 'graphql-tag';

const GET_BILLING_TEMPLATE_LIST = gql`
  query getBillingTemplateList($listInfo: ListInfoInput!) {
    getBillingTemplateList(listInfo: $listInfo) {
      templates {
        templateId
        name
        description
      }
      listInfo {
        page
        sort {
          order
          attribute
        }
        pageSize
        condition
        totalCount
      }
    }
  }
`;

export { GET_BILLING_TEMPLATE_LIST };
